export default __webpack_public_path__ + "assets/images/9fd2eb0b6c1afbc2a67ab821cbad218f.svg";